// src/store/appVersion/index.js
import generalApi from '@/api/general-api'

const state = {
  version: '',
}

const mutations = {
  setVersion(state, val) {
    state.version = val || ''
  },
}

const actions = {
  async fetchVersion({ commit }) {
    try {
      const res = await generalApi.getAppVersion()
      commit('setVersion', res.data.app_version)
    } catch (e) {
      // Manejo de error si lo necesitas
    }
  },
  async updateVersion({ commit }, version) {
    commit('app/loading', true, { root: true })
    try {
      await generalApi.updateAppVersion(version)
      commit(
        'notifications',
        { title: "Versión actualizada", variant: 'success' },
        { root: true },
      )
      commit('setVersion', version)
    } finally {
      location.reload();
    }
  },
}

const getters = {
  getVersion: state => state.version,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
